/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jeferson Araujo",
  title: "Olá, Eu sou Jeferson Araújo",
  subTitle: emoji(
    "Sou DevOps Engineer certificado e administrador de nuvem. Com experiência nas principais ferramentas DevOps e foco no AWS/Azure, especializando  em projetar e implementar estratégias eficientes para maior confiabilidade e escalabilidade em ambientes locais e de nuvem. Tenho um histórico comprovado de otimização de pipelines de CI/CD, automatização de infraestrutura e orquestração de aplicativos em contêineres usando tecnologias de ponta."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1_ZhaSzCfvh5odcKj3pkOuXLgpkCX_jX2/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jefersonaraujo",
  linkedin: "https://www.linkedin.com/in/jefersonaraujo/",
  gmail: "jfs@jefersonaraujo.net.br",
  gitlab: "https://gitlab.com/jefersonaraujo",
  // facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@jefersonaraujo",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {

  
  title: "What I do ",
  // subTitle: "Continuous Integration and Deployment (CI/CD) Implementation",
  skills: [
    emoji(
      "⚡ Provisionar e gerenciar servidores, bancos de dados e outros recursos para hospedagem de sites e aplicativos móveis."
    ),
    emoji("⚡ Configurar e automatizar pipelines de integração contínua e entrega contínua (CI/CD) para código front-end."),
    emoji(
      "⚡ Configurar tecnologias de containerização, como Docker e Kubernetes, para empacotar e implantar aplicativos front-end e back-end de forma escalável e portátil"
    ),
    emoji(
      "⚡ Implementar ferramentas de monitoramento de desempenho, como Prometheus e Grafana, para rastrear métricas de utilização de recursos e desempenho do aplicativo.   "
    ) 
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [

    {
      skillName: "Linux Server",
      fontAwesomeClassname: "fab fa-linux"
    },


    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Other Clouds",
      fontAwesomeClassname: "fas fa-cloud"
    },

    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    }
    ,
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "golang",
      fontAwesomeClassname: "fab fa-golang"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Uni 7 - Centro Universitário 7 de Setembro",
      logo: require("./assets/images/uni-logo.png"),
      subHeader: "Sistemas de Informação",
      // duration: "September 2014 - April 2019",
       desc: "Realizou cursos sobre Engenharia de Software, Segurança Web, Sistemas Operacionais.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Faculdade Descomplica",
      logo: require("./assets/images/d-faculdade.png"),
      subHeader: "Pós-Graduação Lato Sensu em Projetos de Cloud Computing",
      // duration: "September 2013 - April 2017",
      desc: "Estudo sobre tecnologia que possibilita o acesso remoto a softwares, armazenamento de arquivos e processamentos de dados através da internet e com modelos de implantação distintos.",
     // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    },
    {
      schoolName: "Alura",
      logo: require("./assets/images/alura.jpeg"),
      subHeader: "Formação DevOps",
      // duration: "September 2013 - April 2017",
      //desc: "Estudo sobre tecnologia que possibilita o acesso remoto a softwares, armazenamento de arquivos e processamentos de dados através da internet e com modelos de implantação distintos.",
     // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "AWS Cloud", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Azure Cloud",
      progressPercentage: "70%"
    },
    {
      Stack: "Kubernetes",
      progressPercentage: "80%"
    },
    {
      Stack: "Jenkins",
      progressPercentage: "90%"
    },   
    {
      Stack: "Monitoring stack (Elastic, APM, Prometheus, Grafana",
      progressPercentage: "93%"
    },   
    {
      Stack: "Terraform",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Continuous Integration and Deployment (CI/CD) Implementation",
      // company: "Facebook",
      companylogo: require("./assets/images/cicd.png"),
      //date: "June 2018 – Present",
      desc: "Como consultor DevOps especializado em CI/CD, forneço soluções abrangentes de automação em todo o ciclo de vida de desenvolvimento de software (SDLC). Isso envolve automatizar testes de produtos, processos de implantação e gerenciamento de código para manter um controle rigoroso e aumentar a eficiência.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Infrastructure Management Services",     
      companylogo: require("./assets/images/infra.webp"),      
      desc: "Como consultor DevOps especializado em gerenciamento de infraestrutura, meu foco é automatizar o provisionamento de ambientes, estabelecer sistemas de monitoramento para alertas oportunos e permitir escalonamento automático. Esses processos são essenciais para garantir o sucesso do seu produto."
    }
    ,
    {
      role: "Security Management Services (DevSecOps)",     
      companylogo: require("./assets/images/devsecops.jpg"),      
      desc: "Priorizar a integração de medidas de segurança desde os estágios iniciais do SDLC. Essa abordagem, conhecida como DevSecOps, garante integração perfeita de processos de segurança, levando a maior segurança, conformidade e economia."

    },
    {
      role: "Cloud Expertise Services",     
      companylogo: require("./assets/images/cloud.webp"),      
      desc: "Como especialista em nuvem, me especializo no fornecimento de serviços de nuvem abrangentes utilizando AWS, Microsoft Azure e outros. Minha abordagem envolve identificar metas operacionais mensuráveis, gerenciamento eficiente de infraestrutura e projetar soluções baseadas nas melhores práticas."
      
    },
    {
      role: "Docker and Kubernetes Expertise Services ",     
      companylogo: require("./assets/images/k8s.png"),      
      desc: "Com ampla experiência prática, sou especializado em Docker e Kubernetes, oferecendo expertise em diversos aspectos de implantação, operações e gerenciamento eficiente de recursos. O objetivo é garantir desempenho e flexibilidade ideais na implantação de aplicativos."
      
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  // subtitle:
  //   "Certifications",

  achievementsCards: [
    {
      title: "Certified Linux Administrator (LPIC-1)",
      subtitle:
        "Linux Professional Institute (LPI) é o padrão global de certificação e organização de suporte de carreira para profissionais de código aberto.",
      image: require("./assets/images/LPIC-1_250.webp"),
      imageAlt: "LPI",
      footerLink: [
        {
          name: "Certification",
          url: "https://cs.lpi.org/caf/Xamman/certification/verify/LPI000435616/dcz454akqa"
        }
      ]
    }
    ,
    {
      title: "AWS Certified Solutions Architect - Associate",
      subtitle:
        "O AWS Certified Solutions Architect - Associate apresenta conhecimento e habilidades na tecnologia da AWS em uma ampla variedade de serviços da AWS.         Credential ID : 413JYQY2QB4E145H.",
      image: require("./assets/images/aws-arc.png"),
      imageAlt: "aws",
      footerLink: [
        {
          name: "Certification",
          url: "https://cp.certmetrics.com/amazon/en/public/verify/credential"
        }
      ]
    }
    // ,
    // {
    //   title: "AWS Certified Cloud Practitioner",
    //   subtitle:
    //     "O AWS Certified Cloud Practitioner valida a compreensão básica e de alto nível dos serviços, da terminologia e da Nuvem AWS.          Credential ID : ",
    //   image: require("./assets/images/aws-cloud.png"),
    //   imageAlt: "aws",
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://cp.certmetrics.com/amazon/en/public/verify/credential"
    //     }
    //   ]
    // }
    ,

    {
      title: "Microsoft Certified: Azure Administrator Associate",
      subtitle: "Obter a certificação Azure Administrator Associate valida as habilidades e o conhecimento para implementar, gerenciar e monitorar o ambiente Microsoft Azure de uma organização. ",
      image: require("./assets/images/azure-administrator.png"),
      imageAlt: "azure",
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/badges/0aeaeeb1-d731-4da7-b144-3d933351cf3f"},

      ]
    }
    ,

    {
      title: "Microsoft Certified: AZ-900 - Fundamentos do Microsoft Azure",
      subtitle: "Este exame mede sua capacidade de descrever o seguinte: conceitos da nuvem; arquitetura e serviços do Azure e gerenciamento e governança do Azure.",
      image: require("./assets/images/az-900.png"),
      imageAlt: "azure",
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/badges/edfe2b35-a52c-415e-8450-7167936de342/public_url"},

      ]
    }
    ,

    {
      title: "Microsoft Certified: MTA - Database Fundamentals",
      subtitle: "Database Fundamentals demonstraram conhecimento introdutório e habilidades com bancos de dados, incluindo bancos de dados relacionais, como o Microsoft SQL Server",
      image: require("./assets/images/MTA-Database_Fundamentals.png"),
      imageAlt: "azure",
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/earner/earned/badge/762f08ca-862d-4049-aae9-6666430b0357"},

      ]
    }
    ,

    // {
    //   title: "Microsoft Certified: DP900 - Fundamentos de Dados do Azure",
    //   subtitle: "Os ganhadores da certificação Azure Data Fundamentals demonstraram conhecimento básico dos principais conceitos de dados e como eles são implementados usando os serviços de dados do Microsoft Azure.      ",
    //   image: require("./assets/images/dp900.png"),
    //   imageAlt: "azure",
    //   footerLink: [
    //     {name: "Certification", url: "https://www.credly.com/earner/earned/badge/3a06865b-f816-455a-a9fd-ce522cf47c85"},

    //   ]
    // }
    ,

    {
      title: "HashiCorp: Terraform Associate (002)",
      subtitle: "Terraform Associate conhecem os conceitos básicos, habilidades e casos de uso associados ao HashiCorp Terraform de código aberto. Eles entendem e podem utilizar o Terraform de acordo com os objetivos da certificação.",
      image: require("./assets/images/terraform.png"),
      imageAlt: "terraform",
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/earner/earned/badge/a19655ef-f6fc-466d-8033-9debb6fae7f7"},

      ]
    }
    ,

    {
      title: "GitLab Certified Git Associate",
      subtitle: "Indivíduos que obtêm a certificação GitLab Git Certified Associate são capazes de explicar o que é o GitLab e por que as equipes o usam, executar comandos básicos do Git para ramificação, fusão e trabalho remoto e aplicar conceitos e habilidades fundamentais usando o GitLab dentro do ciclo de vida do DevOps",
      image: require("./assets/images/gitlab.png"),
      imageAlt: "gitlab",
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/earner/earned/badge/5022a788-58dd-4463-afa6-ffae1e74c3fa"},

      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  // subtitle:
  //   "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Entre em contato ☎️"),
  subtitle:
    "Discuta um projeto ou apenas queira dizer oi? Minha caixa de entrada está aberta para todos.",
  // number: "+92-0000000000",
  email_address: "jfs@jefersonaraujo.net.br"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
